'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ButtonBase = require('./ButtonBase');

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSvg = require('@homeaway/react-svg');

require('./ButtonIconBase.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ButtonIcon = function (_Component) {
  _inherits(ButtonIcon, _Component);

  function ButtonIcon() {
    _classCallCheck(this, ButtonIcon);

    return _possibleConstructorReturn(this, (ButtonIcon.__proto__ || Object.getPrototypeOf(ButtonIcon)).apply(this, arguments));
  }

  _createClass(ButtonIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          svgMarkup = _props.svgMarkup,
          svgId = _props.svgId,
          circle = _props.circle,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['icon', 'svgMarkup', 'svgId', 'circle', 'className']);

      var buttonIconClassName = (0, _classnames2.default)('btn-icon', className, {
        'btn-icon-circle': circle
      });
      var finalIconMarkup = void 0;

      if (icon) {
        finalIconMarkup = _react2.default.createElement('i', {
          'aria-hidden': true,
          className: 'icon-' + icon
        });
      } else if (svgMarkup) {
        finalIconMarkup = _react2.default.createElement(_reactSvg.SVGIcon, {
          useFill: true,
          className: 'flex-center',
          markup: svgMarkup
        });
      } else if (svgId) {
        finalIconMarkup = _react2.default.createElement('span', {
          className: 'flex-center'
        }, _react2.default.createElement(_reactSvg.SVGIcon, {
          useFill: true,
          id: svgId
        }));
      }

      return _react2.default.createElement(_ButtonBase2.default, _extends({
        pill: false,
        srOnlyLabel: true,
        className: buttonIconClassName
      }, rest), finalIconMarkup, this.props.children);
    }
  }]);

  return ButtonIcon;
}(_react.Component);

ButtonIcon.propTypes = _extends({}, _ButtonBase2.default.propTypes, {
  /** The icon name you want to display, see a full list here:
    * https://github.homeawaycorp.com/pages/ui-toolkit/baseline/release/docs/gt/components.html#glyphicons */
  icon: _propTypes2.default.string,

  /** SVG markup from @homeaway/svg-defs module. Please reference directly from lib/defs/ */
  svgMarkup: _propTypes2.default.string,

  /** ID name of SVG from an SVG Definition block, the xlink:href of the SVG you want. Used in the 'use' tag to grab it's definition from the SVG Definitions */
  svgId: _propTypes2.default.string,

  /** Flag to determine if this component should also have className .btn-icon-circle */
  circle: _propTypes2.default.bool
});
exports.default = ButtonIcon; // eslint-disable-line new-cap